export const ROUTE_KITCHEN = '/kitchen'
export const ROUTE_KITCHEN_COMPLETION = `${ROUTE_KITCHEN}/completion`
